import React from 'react';
import Canonical from './Canonical';
import Header from './home/Header';
import Footer from './home/Footer';

const openIntercom = () => {
    if (window.Intercom) {
        window.Intercom('show');
    }
};

const Contact = () => {
    return (
        <>
        <Canonical path="/contact" />
        <div className="w-full min-h-screen bg-neutral-900">
            <Header />
            <div className="max-w-3xl mx-auto px-8 py-16">
                <h1 className="!text-white text-4xl lg:text-5xl font-bold font-['Montserrat'] mb-4">Contact Us</h1>
                <p className="!text-stone-300 text-lg font-medium font-['Inter'] mb-12">Have a question or want to learn more? We'd love to hear from you.</p>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-8">
                    {/* Live Chat */}
                    <button
                        onClick={openIntercom}
                        className="p-6 bg-neutral-800 border border-neutral-700 rounded-lg hover:border-blue-500 transition-colors text-left group"
                    >
                        <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center mb-4">
                            <i className="fa fa-comments text-white text-xl"></i>
                        </div>
                        <h3 className="!text-white text-lg font-bold font-['Montserrat'] mb-2">Live Chat</h3>
                        <p className="!text-stone-300 text-sm font-['Inter'] mb-3">Chat with us directly — we typically respond within a few hours.</p>
                        <span className="text-blue-400 text-sm font-bold font-['Inter'] group-hover:text-blue-300 transition-colors">
                            Start a conversation <i className="fa fa-arrow-right text-xs ml-1"></i>
                        </span>
                    </button>

                    {/* Phone */}
                    <a
                        href="tel:+18888649130"
                        className="p-6 bg-neutral-800 border border-neutral-700 rounded-lg hover:border-blue-500 transition-colors text-left group block"
                    >
                        <div className="w-12 h-12 bg-blue-600 rounded-lg flex items-center justify-center mb-4">
                            <i className="fa fa-phone text-white text-xl"></i>
                        </div>
                        <h3 className="!text-white text-lg font-bold font-['Montserrat'] mb-2">Call Us</h3>
                        <p className="!text-stone-300 text-sm font-['Inter'] mb-3">Talk to our AI assistant — powered by our own platform.</p>
                        <span className="text-blue-400 text-lg font-bold font-['Inter'] group-hover:text-blue-300 transition-colors">
                            1-888-864-9130
                        </span>
                    </a>
                </div>

                {/* Email contacts */}
                <div className="p-6 bg-neutral-800 border border-neutral-700 rounded-lg">
                    <h2 className="!text-white text-lg font-bold font-['Montserrat'] mb-4">Email</h2>
                    <div className="grid grid-cols-2 sm:grid-cols-4 gap-4">
                        <div>
                            <div className="!text-stone-400 text-xs font-bold font-['Inter'] uppercase tracking-wider mb-1">Sales</div>
                            <a href="mailto:sales@remote-assistant.ai" className="text-blue-400 hover:text-blue-300 text-sm font-medium font-['Inter']">
                                sales@remote-assistant.ai
                            </a>
                        </div>
                        <div>
                            <div className="!text-stone-400 text-xs font-bold font-['Inter'] uppercase tracking-wider mb-1">Support</div>
                            <a href="mailto:support@remote-assistant.ai" className="text-blue-400 hover:text-blue-300 text-sm font-medium font-['Inter']">
                                support@remote-assistant.ai
                            </a>
                        </div>
                        <div>
                            <div className="!text-stone-400 text-xs font-bold font-['Inter'] uppercase tracking-wider mb-1">Investors</div>
                            <a href="mailto:investors@remote-assistant.ai" className="text-blue-400 hover:text-blue-300 text-sm font-medium font-['Inter']">
                                investors@remote-assistant.ai
                            </a>
                        </div>
                        <div>
                            <div className="!text-stone-400 text-xs font-bold font-['Inter'] uppercase tracking-wider mb-1">Legal</div>
                            <a href="mailto:legal@remote-assistant.ai" className="text-blue-400 hover:text-blue-300 text-sm font-medium font-['Inter']">
                                legal@remote-assistant.ai
                            </a>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </div>
        </>
    );
};

export default Contact;
